import React from 'react';
import logo from "../assets/splash logo.svg";
import { Link, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const Privacy = () => {

    const navigate = useNavigate();

    const handleLinkClick = () => {
        navigate('/');
        window.scrollTo(0, 0);
    };

    return (
        <div className='flex bg-white flex-col lg:pl-[200px] ms:pl-[30px] pt-[80px] pb-[100px]'>
            <Helmet>
                <title>Swop | Privacy Policy</title>
            </Helmet>
            <div className="fixed top-0 left-0 w-full bg-white shadow-md z-10 px-4 py-4 flex items-center">
                <Link to={'/'} onClick={handleLinkClick} className="flex items-center cursor-pointer">
                <img src={logo} alt="Swop Logo" className="w-[52.12px] lg:ml-[180px] h-[50px] sm:w-[40px] sm:h-[40px]" />
                <h1 className="uppercase text-spay-logo-text font-bold text-3xl sm:text-2xl ml-2">
                    Swop
                </h1>
                </Link>
            </div>
            <div className='lg:text-[35px] ms:text-[26px] mt-[50px] text-gray-900 font-bold'>
                Privacy Policy
            </div>
            <div className='mt-[20px] lg:text-[18px] ms:text-[14px] lg:w-[70%] ms:w-[90%]'>
                Thank you for choosing SWOP, a fintech mobile wallet app provided by
                SPay Business Solutions Limited. This Privacy Policy outlines how we
                collect, use, and protect your personal information. By using the SWOP
                mobile wallet app ("the App"), you consent to the practices described
                in this Privacy Policy.
            </div>

            <div className='flex flex-col mt-5'>
                <div className='lg:text-[20px] ms:text-[16px] text-black font-medium'>
                    1. Information Collected
                </div>
                <div className='mt-[20px] lg:text-[18px] ms:text-[14px] lg:w-[70%] ms:w-[90%]'>
                    We collect the following types of information:
                </div>
                <div className='mt-[20px] lg:text-[18px] ms:text-[14px] lg:w-[70%] ms:w-[90%]'>
                - Full Name - Email Address - Phone Number - Home Address - Pictures -
                Bank Verification Number (BVN) - Age - Gender
                </div>
                <div className='mt-[20px] lg:text-[18px] ms:text-[14px] lg:w-[70%] ms:w-[90%]'>
                    This information is collected for the purpose of providing you with
                    our services, including account verification, transaction processing,
                    customer support, and legal and regulatory compliance.
                </div>
            </div>

            <div className='flex flex-col mt-5'>
                <div className='lg:text-[20px] ms:text-[16px] text-black font-medium'>
                    2. Use of Information
                </div>
                <div className='mt-[20px] lg:text-[18px] ms:text-[14px] lg:w-[70%] ms:w-[90%]'>
                    We use the collected information for the following purposes:
                </div>
                <div className='mt-[20px] lg:text-[18px] ms:text-[14px] lg:w-[70%] ms:w-[90%]'>
                    - Account creation and authentication - Transaction processing -
                    Customer support - Communication regarding account activity and
                    updates - Legal and regulatory compliance
                </div>
            </div>

            <div className='flex flex-col mt-5'>
                <div className='lg:text-[20px] ms:text-[16px] text-black font-medium'>
                    3. Data Security
                </div>
                <div className='mt-[20px] lg:text-[18px] ms:text-[14px] lg:w-[70%] ms:w-[90%]'>
                    SPay Business Solutions Limited employs industry-standard security
                    measures to protect your personal information from unauthorized
                    access, disclosure, alteration, and destruction. However, no data
                    transmission or storage system is completely secure, and we cannot
                    guarantee the absolute security of your data.
                </div>
            </div>

            <div className='flex flex-col mt-5'>
                <div className='lg:text-[20px] ms:text-[16px] text-black font-medium'>
                    4. Third-Party Sharing
                </div>
                <div className='mt-[20px] lg:text-[18px] ms:text-[14px] lg:w-[70%] ms:w-[90%]'>
                    We do not sell, trade, or otherwise transfer your personal information
                    to third parties without your consent. However, we may share your
                    information with trusted third parties who assist us in operating the
                    App and providing services, provided they agree to keep this
                    information confidential.
                </div>
            </div>

            <div className='flex flex-col mt-5'>
                <div className='lg:text-[20px] ms:text-[16px] text-black font-medium'>
                    5. Third-Party Logins
                </div>
                <div className='mt-[20px] lg:text-[18px] ms:text-[14px] lg:w-[70%] ms:w-[90%]'>
                    SWOP does not use third-party logins such as Google or Facebook. User
                    authentication is solely based on the password provided during
                    registration.
                </div>
            </div>

            <div className='flex flex-col mt-5'>
                <div className='lg:text-[20px] ms:text-[16px] text-black font-medium'>
                    6. User Control
                </div>
                <div className='mt-[20px] lg:text-[18px] ms:text-[14px] lg:w-[70%] ms:w-[90%]'>
                    You have the right to review, update, or delete your personal
                    information at any time. You can do this by accessing your account
                    settings within the App or by contacting our customer support.
                </div>
            </div>

            <div className='flex flex-col mt-5'>
                <div className='lg:text-[20px] ms:text-[16px] text-black font-medium'>
                7. Cookies and Tracking
                </div>
                <div className='mt-[20px] lg:text-[18px] ms:text-[14px] lg:w-[70%] ms:w-[90%]'>
                    The App may use cookies and similar tracking technologies to enhance
                    user experience. You can choose to disable cookies in your browser
                    settings, but this may affect the functionality of the App.
                </div>
            </div>

            <div className='flex flex-col mt-5'>
                <div className='lg:text-[20px] ms:text-[16px] text-black font-medium'>
                8. Children's Privacy
                </div>
                <div className='mt-[20px] lg:text-[18px] ms:text-[14px] lg:w-[70%] ms:w-[90%]'>
                    SWOP is not intended for use by individuals under the age of 18. We do
                    not knowingly collect personal information from children. If you are a
                    parent or guardian and believe that your child has provided us with
                    personal information, please contact us, and we will take steps to
                    delete such information.
                </div>
            </div>

            <div className='flex flex-col mt-5'>
                <div className='lg:text-[20px] ms:text-[16px] text-black font-medium'>
                9. Transfer of Data
                </div>
                <div className='mt-[20px] lg:text-[18px] ms:text-[14px] lg:w-[70%] ms:w-[90%]'>
                    As part of our service provision, we may rely on third-party servers,
                    databases co-located with hosting providers, resident in foreign
                    jurisdictions, which constitutes the transfer of your personal data to
                    computers or servers in foreign countries. We take steps designed to
                    ensure that the data we collect under this Privacy Policy is processed
                    and protected according to the provisions of this Policy and
                    applicable law wherever the data is located.
                </div>
                <div className='mt-[20px] lg:text-[18px] ms:text-[14px] lg:w-[70%] ms:w-[90%]'>
                    Where personal data is to be transferred to a country outside Nigeria,
                    SPay shall put adequate measures in place to ensure the security of
                    such personal data. Any transfer of personal data out of Nigeria will
                    be in accordance with the provisions of relevant data protection
                    regulations. In particular, SPay shall, among other things, use
                    contractual terms to ensure protection of the data or ensure the
                    country has adequate data protection laws (i.e. listed in
                    Nigeria&rsquo;s National Information Technology Development
                    Agency&rsquo;s [&ldquo;NITDA&rdquo;] White List of Countries, or the
                    General Data Protection Regulation&rsquo;s [&ldquo;GDPR&rdquo;]
                    Adequacy List).
                </div>
                <div className='mt-[20px] lg:text-[18px] ms:text-[14px] lg:w-[70%] ms:w-[90%]'>
                    Should you wish to transfer personal data to a country deemed to have
                    inadequate data protection laws, SPay will take all necessary steps to
                    ensure that informed consent is obtained from you, and you are aware
                    of the risks entailed with such transfer. In any instance, SPay will
                    ensure personal data is transmitted in a safe and secure manner.
                    Details of the protection given when your personal data is transferred
                    abroad, and details of the basis of such transfers shall be provided
                    to you upon request.
                </div>
            </div>

            <div className='flex flex-col mt-5'>
                <div className='lg:text-[20px] ms:text-[16px] text-black font-medium'>
                    10. Grounds for Processing of Personal Data
                </div>
                <div className='mt-[20px] lg:text-[18px] ms:text-[14px] lg:w-[70%] ms:w-[90%]'>
                    Processing of Personal Information by SPay shall be lawful if at least
                    one of the following applies:
                </div>
                <div className='mt-[20px] lg:text-[18px] ms:text-[14px] lg:w-[70%] ms:w-[90%]'>
                    <div className='ml-[20px]'>
                        &#8226; the Data Subject has given consent to the processing of his/her Personal Information for one or more specific purposes;
                    </div>
                    <div className='ml-[20px] mt-[20px]'>
                        &#8226; the processing is necessary for the performance of a contract to which the Data Subject is party or in order to take steps at the request of the Data Subject prior to entering into a contract;
                    </div>
                    <div className='ml-[20px] mt-[20px]'>
                        &#8226; processing is necessary for compliance with a legal obligation to which SPay is subject;
                    </div>
                    <div className='ml-[20px] mt-[20px]'>
                        &#8226; processing is necessary in order to protect the vital interests of the Data Subject or of another natural person; and
                    </div>
                    <div className='ml-[20px] mt-[20px]'>
                        &#8226; processing is necessary for the performance of a task carried out in the public interest or in exercise of official public mandate vested in SPay.
                    </div>
                </div>
            </div>

            <div className='flex flex-col mt-5'>
                <div className='lg:text-[20px] ms:text-[16px] text-black font-medium'>
                    11. Choices and Rights
                </div>
                <div className='mt-[20px] lg:text-[18px] ms:text-[14px] lg:w-[70%] ms:w-[90%]'>
                    Individuals who have Personal Information held by SPay are entitled to
                    reach out to SPay to exercise the following rights:
                </div>
                <div className="mt-[20px] lg:text-[18px] ms:text-[14px] lg:w-[70%] ms:w-[90%]">
                    <div className="ml-[20px] ">&#8226; Right to request for and access any Personal Information collected and stored by SPay;</div>
                    <div className="ml-[20px] mt-[10px] ">&#8226; Right to be informed regarding their Personal Information;</div>
                    <div className="ml-[20px] mt-[10px] ">&#8226; Right to be informed about appropriate safeguards in place where data is transferred abroad;</div>
                    <div className="ml-[20px] mt-[10px] ">&#8226; Right to object to automated decision making and processing;</div>
                    <div className="ml-[20px] mt-[10px] ">&#8226; Right to request rectification and modification of Personal Information which SPay keeps;</div>
                    <div className="ml-[20px] mt-[10px] ">&#8226; Right to request the movement of data from SPay to a third party - this is the right to the portability of data;</div>
                    <div className="ml-[20px] mt-[10px] ">&#8226; Right to revoke consent</div>
                    <div className="ml-[20px] mt-[10px] ">&#8226; Right to object to direct marketing, and to request that SPay restricts the processing of their information; and</div>
                    <div className="ml-[20px] mt-[10px] ">&#8226; Right to submit a complaint to the National Information Technology Development Agency (NITDA).</div>
                </div>

                <div className='mt-[20px] lg:text-[18px] ms:text-[14px] lg:w-[70%] ms:w-[90%]'>
                    Your request will be reviewed and answered by SPay&rsquo;s Data
                    Protection Officer within a 30-day period.
                </div>
            </div>

            <div className='flex flex-col mt-5'>
                <div className='lg:text-[20px] ms:text-[16px] text-black font-medium'>
                    12. Changes to This Privacy Policy
                </div>
                <div className='mt-[20px] lg:text-[18px] ms:text-[14px] lg:w-[70%] ms:w-[90%]'>
                    We may need to update, modify or amend our Privacy Policy as our
                    technology evolves and as required by law. If we materially change the
                    ways in which we use or share personal data previously collected from
                    you through our Services, we will provide notice or obtain consent
                    regarding such changes as may be required by law. The Privacy Policy
                    will apply from the effective date provided on our website.
                </div>
            </div>

            <div className='flex flex-col mt-5'>
                <div className='lg:text-[20px] ms:text-[16px] text-black font-medium'>
                    13. Policy Violations
                </div>
                <div className='mt-[20px] lg:text-[18px] ms:text-[14px] lg:w-[70%] ms:w-[90%]'>
                    Any violation of this Privacy Policy should be brought to the
                    attention of the Data Protection Officer (details below) for
                    appropriate sanctioning and treatment.
                </div>
            </div>

            <div className='flex flex-col mt-5'>
            <div className='lg:text-[20px] ms:text-[16px] text-black font-medium'>
                    14. Contact
                </div>
                <div className='mt-[20px] lg:text-[18px] ms:text-[14px] lg:w-[70%] ms:w-[90%]'>
                &nbsp;SPay
                &rsquo;s Data Protection Officer (DPO)
                </div>
            </div>

            <div className='flex flex-col mt-3'>
                <div className='lg:text-[18px] ms:text-[14px] text-black'>
                    If you have any questions relating to this Privacy Policy or would
                    like to find out more about exercising your data protection rights,
                    please reach out to our DPO via email at dpo@spaybusiness.com.
                </div>
                <div className='lg:text-[18px] ms:text-[14px] text-black'>
                    For any further queries, our Data Protection Officer, may be reached
                    at the following address:
                </div>
                <div className=' mt-2 lg:text-[18px] ms:text-[14px] font-medium text-black'>
                    6 Mojidi Street, Off Toyin Street, &nbsp;Ikeja, Lagos, Nigeria.
                </div>
            </div>

        </div>
    );
}

export default Privacy